import { View, ViewType } from "@common/types/views/views";

export enum HistoryInvoiceTemplateDetailsColumn {
    TIME = "time",
    TEMPLATE_NAME = "templateName",
    PREVIOUS = "previous",
    MODIFIED = "modified",
    CHANGE = "change",
}

export interface HistoryInvoiceTemplateDetailsView extends View {
    type: ViewType.HISTORY_UPDATED_TRANSACTION;
    columns: Array<{ id: HistoryInvoiceTemplateDetailsColumn }>;
}

export type HistoryInvoiceTemplateChangeColumn = Exclude<
    HistoryInvoiceTemplateDetailsColumn,
    HistoryInvoiceTemplateDetailsColumn.CHANGE
>;

export type HistoryInvoiceTemplateContentColumn = Exclude<
    HistoryInvoiceTemplateDetailsColumn,
    | HistoryInvoiceTemplateDetailsColumn.PREVIOUS
    | HistoryInvoiceTemplateDetailsColumn.MODIFIED
>;
